import { getData } from '../../axiosServices'

export const getDailyPracticeReport = (coeId,labID) => {
    const url = `reports/coe/${coeId}/lab/${labID}`;
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }
    return getData(url, { headers });
};

export const getlearnerSubmission = (labID,makerplanId,moduleId,topicId,dailyPracticeId) => {
    const url = `reports/lab/${labID}/makerplan/${makerplanId}/module/${moduleId}/topic/${topicId}/dailypractice/${dailyPracticeId}`;
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }
    return getData(url, { headers });
};
